// Clock in/out window rules, shared by Duties and Dashboard. All times are epoch milliseconds.
//   Clock IN:  from shift.start - 1h until shift.end.
//   Clock OUT: until shift.end + 3h (hard stop). After that the server closes the timelog.
export const CLOCK_IN_EARLY_MS = 60 * 60 * 1000;
export const HARD_STOP_MS = 3 * 60 * 60 * 1000;

export const TOO_EARLY_MESSAGE = "It's too early to clock in. Clock in as unscheduled for the current shift.";
export const ENDED_MESSAGE = 'This shift has ended. Clock in as unscheduled for the current shift.';
export const CLOSED_MESSAGE = 'This shift is closed.';
export const ALREADY_CLOCKED_IN_MESSAGE = 'You are already clocked in.';
export const SHIFT_NOT_FOUND_MESSAGE = 'That shift no longer exists.';
export const GENERIC_CLOCK_MESSAGE = 'Clock action failed. Please try again.';

export const isPastHardStop = (shift, now) => now > shift.end + HARD_STOP_MS;

export const checkClockIn = (shift, now) => {
    if (now < shift.start - CLOCK_IN_EARLY_MS) return { ok: false, reason: 'too-early' };
    if (now > shift.end) return { ok: false, reason: 'ended' };

    return { ok: true };
};

export const checkClockOut = (shift, now) => {
    if (isPastHardStop(shift, now)) return { ok: false, reason: 'hard-stop' };

    return { ok: true };
};

// Active = open timelog for this patroller and not past the hard stop.
export const isShiftActive = (shift, patrollerId, now) => {
    const open = shift?.timelogs?.some(t => t?.patroller === patrollerId && t.started && !t.stopped);

    return !!open && !isPastHardStop(shift, now);
};

// Newest active shift wins; null when none.
export const pickActiveShift = (shifts, patrollerId, now) => {
    const open = (shifts ?? []).filter(s => isShiftActive(s, patrollerId, now));

    if (open.length === 0) return null;

    return open.reduce((newest, s) => (s.start > newest.start ? s : newest));
};

// Maps a clockInOut result to the text shown to the patroller.
export const clockErrorMessage = (result) => {
    if (result?.status === 409 && result.error === 'manage/shift-window-closed') {
        if (result.reason === 'too-early') return TOO_EARLY_MESSAGE;
        if (result.reason === 'ended') return ENDED_MESSAGE;
        if (result.reason === 'hard-stop') return CLOSED_MESSAGE;
    }

    if (result?.status === 409 && result.error === 'manage/already-clocked-in') return ALREADY_CLOCKED_IN_MESSAGE;
    if (result?.status === 404 && result.error === 'manage/shift-not-found') return SHIFT_NOT_FOUND_MESSAGE;

    return GENERIC_CLOCK_MESSAGE;
};
